import(/* webpackMode: "eager" */ "/vercel/path0/src/components/gallery/GalleryComponent.tsx")